var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2423",
    "data-name": "Group 2423",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9933",
    "data-name": "Path 9933",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9934",
    "data-name": "Path 9934",
    d: "M12,2q-.327,0-.642.005l-.616.017-.3.013-.579.034-.553.046c-4.785.464-6.732,2.411-7.2,7.2l-.046.553-.034.579c-.005.1-.01.2-.013.3l-.017.616,0,.318V12q0,.327.005.642l.017.616.013.3.034.579.046.553c.464,4.785,2.411,6.732,7.2,7.2l.553.046.579.034c.1,0,.2.01.3.013l.616.017L12,22l.642,0,.616-.017.3-.013.579-.034.553-.046c4.785-.464,6.732-2.411,7.2-7.2l.046-.553.034-.579c0-.1.01-.2.013-.3L22,12.642,22,12l0-.642-.017-.616-.013-.3-.034-.579-.046-.553c-.464-4.785-2.411-6.732-7.2-7.2l-.553-.046-.579-.034-.3-.013-.616-.017-.318,0H12Zm2.293,7.293a1,1,0,0,1,1.5,1.32l-.083.094-4,4a1,1,0,0,1-1.32.083l-.094-.083-2-2a1,1,0,0,1,1.32-1.5l.094.083L11,12.585Z",
    fill: "#009a1e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.c2ee27cb7fbec0f4a3b95a97933caa59.svg";
export { ForwardRef as ReactComponent };